import { render, staticRenderFns } from "./MulShopOamount.vue?vue&type=template&id=402e2155&scoped=true&"
import script from "./MulShopOamount.vue?vue&type=script&lang=ts&"
export * from "./MulShopOamount.vue?vue&type=script&lang=ts&"
import style0 from "./MulShopOamount.vue?vue&type=style&index=0&id=402e2155&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e2155",
  null
  
)

export default component.exports